module.exports = __webpack_public_path__ + "img/telegram.7f4cbc20.svg";